import {noop} from "lodash";
import {
    Cancel_outbound,
    Cancel_outbound_ecommerce,
    Cancel_outbound_wholesale, Cancel_Wholesale_Batch,
    Change_ASN_Submit,
    Change_Order_Status,
    Create_And_Save_Warehouse_Outbound,
    Create_outbound_ecommerce,
    Create_Warehouse_Outbound,
    Dict_Type,
    Download_Product_Template,
    Ecommerce_Information, Ecommerce_Order_Copy,
    Ecommerce_Order_Status,
    Edit_And_Save_Warehouse_Outbound,
    Edit_And_Submit_outbound_ecommerce,
    Edit_outbound_ecommerce, Edit_Ship_Status,
    Edit_temu_outbound_ecommerce,
    Edit_Warehouse_Outbound,
    Export_Ecommerce,
    Export_Ecommerce_Details, Export_Ecommerce_Details_By_Filter,
    Export_Inbound,
    Export_Wholesale,
    Filter_Ecommerce,
    Filter_Wholesale,
    Outbound_Stock_Check,
    Outbound_Stock_Qty, Platform_List_Owner,
    Release_Ecommerce,
    Release_Wholesale,
    SendEmailForDutyInfo,
    Submit_Wholesale, Submit_Wholesale_Batch,
    Warehouse_Check, Warehouse_List_Owner,
    Wholesale_Information,
    Withdraw_Ecommerce,
    Withdraw_Wholesale
} from "../../config";
import api from "../../api/api";
import {InboundsActionType} from "../inbounds/inboundsAction";
import {InventoryActionType} from "../inventory/inventoryAction";
import moment from "moment";
import LocalStorage from "../../utils/LocalStorage";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import progressApi from "../../api/progressApi";

export const OutBoundsActionType = {
    OutBounds_SEARCH_LIST:'INBOUNDS_SEARCH_LIST',
    CUSTOMER_LIST:'CUSTOMER_LIST',
    CARRIER_LIST:'CARRIER_LIST',
    CARRIER_LIST_WHOLESALE:'CARRIER_LIST_WHOLESALE',
    SLA_LIST:'SLA_LIST',
    ADDITIONAL_REQ_LIST:'ADDITIONAL_REQ_LIST',
    CARRIER_SLA_LIST:'CARRIER_SLA_LIST',
    PLATFORM_LIST:'PLATFORM_LIST',
    PLATFORM_LIST_OWNER:'PLATFORM_LIST_OWNER',
    WAREHOUSE_LIST_OWNER:'WAREHOUSE_LIST_OWNER'
}

export const warehouseFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleList)) return null;

        const url = `${Filter_Wholesale}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:OutBoundsActionType.OutBounds_SEARCH_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}


export const ecommerceFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceList)) return null;
        const url = `${Filter_Ecommerce}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:OutBoundsActionType.OutBounds_SEARCH_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}


export const carrier_List = (onSuccess = noop,onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_carrier_choice_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:OutBoundsActionType.CARRIER_LIST,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {

        onError(e.message)
    }

}

export const carrier_List_Wholesale = (onSuccess = noop,onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_carrier_choice_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:OutBoundsActionType.CARRIER_LIST_WHOLESALE,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {

        onError(e.message)
    }

}

export const platform_List = (onSuccess = noop,onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_plat_code_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:OutBoundsActionType.PLATFORM_LIST,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {

        onError(e.message)
    }

}

export const platform_List_owner = (onSuccess = noop,onError = noop)  => async dispatch => {
    try {
        const url = `${Platform_List_Owner}`
        const response = await api.get(url )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:OutBoundsActionType.PLATFORM_LIST_OWNER,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {

        onError(e.message)
    }

}

export const warehouse_List_owner = (onSuccess = noop,onError = noop)  => async dispatch => {
    try {
        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)) return null;
        const url = `${Warehouse_List_Owner}`
        const response = await api.post(url,{})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:OutBoundsActionType.WAREHOUSE_LIST_OWNER,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {

        onError(e.message)
    }

}

export const Additional_Requirement_List = (onSuccess = noop,onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'wholesale_outbound_order_addreq'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:OutBoundsActionType.ADDITIONAL_REQ_LIST,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        console.log(e)
        onError(e.message)
    }

}

export const SLA_List = (onSuccess = noop,onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_sla_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:OutBoundsActionType.SLA_LIST,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        console.log(e)
        onError(e.message)
    }

}

export const carrier_SLA_List = (onSuccess = noop,onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_courier_sla_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:OutBoundsActionType.CARRIER_SLA_LIST,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        console.log(e)
        onError(e.message)
    }

}

export const createOutBoundsWarehouse = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleAdd)) return null;
        const url = `${Create_Warehouse_Outbound}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.msg)
            // onSuccess('OutboundPage.Create Warehouse Outbound Successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}

export const createAndSaveOutBoundsWarehouse = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleSaveAndSubmit)) return null;
        const url = `${Create_And_Save_Warehouse_Outbound}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.msg)
            // onSuccess('OutboundPage.Create and Submit Warehouse Outbound Successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}

export const EditAndSaveOutBoundsWarehouse = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleModifyAndSubmit)) return null;
        const url = `${Edit_And_Save_Warehouse_Outbound}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('OutboundPage.Edit and Submit Warehouse Outbound Successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}

export const editOutBoundsWarehouse = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleModify)) return null;
        const url = `${Edit_Warehouse_Outbound}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('OutboundPage.Edit Warehouse Outbound Successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}

export const warehouseAddressCheck = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        // if (!checkPermission(PERMISSION_DICT.WarehouseCheck)) return null;
        const url = `${Warehouse_Check}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response?.data?.data)
        } else {
            onError(response?.data?.msg,response?.data?.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const sendEmailForDutyInfo = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        // if (!checkPermission(PERMISSION_DICT.OutboundWholesaleModify)) return null;
        const url = `${SendEmailForDutyInfo}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        // if(response?.status === 200 && response.data.code === 200){
        //
        // } else {
        //     onError(response.data?.msg,response?.data.code)
        // }
    }
    catch (e) {

        onError(e.message)
    }
}



export const ecommerceWithdraw = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceWithdraw)) return null;
        const url = `${Withdraw_Ecommerce}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`EcommercePage.Withdraw e-commerce order successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const ecommerceRelease = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceRelease)) return null;
        const url = `${Release_Ecommerce}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`Release E-commerce order successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const wholesaleRelease = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleRelease)) return null;
        const url = `${Release_Wholesale}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`OutboundPage.Release Wholesale order successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}


export const wholesaleWithdraw = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleWithdraw)) return null;
        const url = `${Withdraw_Wholesale}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`OutboundPage.Withdraw wholesale order successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}


export const wholesaleStockCheck= (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleStockCheck)) return null;
        const url = `${Outbound_Stock_Check}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.msg)
        } else {
            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}


export const wholesaleStockQty= (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleStockCheck)) return null;
        const url = `${Outbound_Stock_Qty}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}



export const wholesaleSubmit = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleChange)) return null;
        const url = `${Change_Order_Status}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`OutboundPage.Submit wholesale order successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const wholesaleBatchSubmit = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleChange)) return null;
        const url = `${Submit_Wholesale_Batch}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const wholesaleBatchCancel = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleDelete)) return null;
        const url = `${Cancel_Wholesale_Batch}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}



export const wholesaleInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleInfo)) return null;
        const url = `${Wholesale_Information}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response?.data.msg)
        }

    } catch (e) {
        console.log(e)
        onError(e.message)
    }
}

export const downloadOutboundWholesaleTemplate = (onSuccess= noop, onError = noop) => async () =>{

    try{
        if (!checkPermission(PERMISSION_DICT.TemplateFileDownload)) return null;

        const xurl = `${Download_Product_Template}`
        const customer = !checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        const fileName = customer ? 'Customer_Warehouse_Order_Template.xlsx':'Warehouse_Order_Template.xlsx'
        const response = await api.get(xurl,{params: { fileName: fileName },
            responseType: 'blob' })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Warehouse_Order_Template_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            console.error('Failed to download file. Server responded with status:', response.status);
            onError(`Failed to download file. Server responded with status:${response.status}`)
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }


}

export const downloadOutboundWholesaleInfo = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleExport)) return null;

        const xurl = `${Export_Wholesale}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });



        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Wholesale_Outbound_Information_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadOutboundEcommerceInfo = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceExport)) return null;
        const xurl = `${Export_Ecommerce}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });



        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Ecommerce_Outbound_Information_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadOutboundEcommerceDetailInfoFilter = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceExport)) return null;
        const xurl = `${Export_Ecommerce_Details_By_Filter}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });



        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Ecommerce_Outbound_Information_With_Details_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadOutboundEcommerceInfoWithDetails = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceExport)) return null;
        const xurl = `${Export_Ecommerce_Details}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });



        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Ecommerce_Outbound_Information_With_Details_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}
export const ecommerceSubmit = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceChange)) return null;
        const url = `${Ecommerce_Order_Status}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`OutboundPage.Submit ecommerce order successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const ecommerceCopy = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
            if (!checkPermission(PERMISSION_DICT.OutboundEcommerceCopy)) return null;
            const url = `${Ecommerce_Order_Copy}`
            const response = await api.post(url, {...data})
                .then(res=>res)


            if(response?.status === 200 && response.data.code === 200){
                onSuccess('EcommercePage.Create Ecommerce Outbound Successfully')
            } else {

                onError(response.data?.msg,response?.data.code)
            }

        }
        catch (e) {

            onError(e.message)
        }
    }


// export const change_order_status = (data,onSuccess = noop, onError = noop) => async dispatch => {
//     try {
//
//         const url = `${Change_Order_Status}`
//         const response = await api.post(url,{...data})
//             .then(res=>res)
//
//
//         if(response?.status === 200 && response.data.code === 200){
//
//             onSuccess(`Update ${response.data.msg} Order status successfully`)
//         } else {
//
//             onError(response.data.msg)
//         }
//
//     } catch (e) {
//
//         onError(e.message)
//     }
// }


export const ecommerceInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceInfo)) return null;
        const url = `${Ecommerce_Information}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response.data.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}



// export const cancelOutBounds = (data, onSuccess = noop,onError = noop) => async dispatch => {
//
//     try {
//
//         if (!checkPermission(PERMISSION_DICT.OutboundDataDelete)) return null;
//         const url = `${Cancel_outbound}`
//         const response = await api.post(url, {...data})
//             .then(res=>res)
//
//
//         if(response?.status === 200 && response.data.code === 200){
//             onSuccess(`Cancel Outbound Successfully, ${response.data.data.msg}`)
//         } else {
//             let errorMsg = ""
//             if (!!response?.data?.msg && response?.data?.msg !== "操作成功"){
//                 errorMsg += response.data?.msg
//             }
//             if (!!response?.data?.data?.msg){
//                 errorMsg += response?.data?.data?.msg
//             }
//
//             onError(errorMsg,response?.data.code)
//         }
//
//     }
//     catch (e) {
//
//         onError(e.message)
//     }
// }

export const cancelOutBoundsEcommerce = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceDelete)) return null;
        const url = `${Cancel_outbound_ecommerce}`
        const response = await progressApi.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`EcommercePage.Cancel Outbound Ecommerce Order Successfully`)
        } else {
            let errorMsg = ""
            if (!!response?.data?.msg && response?.data?.msg !== "操作成功"){
                errorMsg += response.data?.msg
            }
            if (!!response?.data?.data?.msg){
                errorMsg += response?.data?.data?.msg
            }

            onError(errorMsg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}

export const cancelOutBoundsWholesale = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleDelete)) return null;
        const url = `${Cancel_outbound_wholesale}`
        const response = await progressApi.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`OutboundPage.Cancel Outbound Wholesale Order Successfully`)
        } else {
            let errorMsg = ""
            if (!!response?.data?.msg && response?.data?.msg !== "操作成功"){
                errorMsg += response.data?.msg
            }
            if (!!response?.data?.data?.msg){
                errorMsg += response?.data?.data?.msg
            }

            onError(errorMsg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}

export const editTemuEcommercePriority = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        // if (!checkPermission(PERMISSION_DICT.OutboundWholesaleDelete)) return null;
        const url = `${Edit_temu_outbound_ecommerce}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`Edit Temu outbound order shipping priority successfully`)
        } else {
            let errorMsg = ""
            if (!!response?.data?.msg && response?.data?.msg !== "操作成功"){
                errorMsg += response.data?.msg
            }
            if (!!response?.data?.data?.msg){
                errorMsg += response?.data?.data?.msg
            }

            onError(errorMsg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}

export const editOutBoundsEcommerce = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceModify)) return null;
        const url = `${Edit_outbound_ecommerce}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('EcommercePage.Edit Ecommerce Outbound Successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}

export const editAndSubmitOutBoundsEcommerce = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceModifyAndSubmit)) return null;
        const url = `${Edit_And_Submit_outbound_ecommerce}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('EcommercePage.Edit And Submit Ecommerce Outbound Successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}


export const createOutBoundsEcommerce = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.OutboundEcommerceCopy)) return null;
        const url = `${Create_outbound_ecommerce}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('EcommercePage.Create Ecommerce Outbound Successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}

export const updateOutboundShipStatus = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.OutboundWholesaleModifyShipStatus)) return null;
        const url = `${Edit_Ship_Status}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('OutboundPage.Shipment Status Save Successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}



